/**
 * PreviewImpressum — Impressum (legal notice) content page preview
 */

interface PreviewImpressumProps {
  settings: {
    companyLegal?: {
      name?: string;
      address?: string;
      uid?: string;
      phone?: string;
      email?: string;
      owner?: string;
    };
    [key: string]: any;
  };
  components: any;
}

export function PreviewImpressum({ settings }: PreviewImpressumProps) {
  const legal = settings.companyLegal || {};

  return (
    <div className="legal-page">
      <div className="container">
        <h1>Impressum</h1>

        <h2>Angaben gem&auml;ss Schweizer Recht</h2>
        <p>
          <strong>{legal.name || ''}</strong><br />
          {legal.address || ''}<br />
          {legal.uid && <>UID: {legal.uid}<br /></>}
        </p>

        <h2>Kontakt</h2>
        <p>
          Telefon: {legal.phone || ''}<br />
          E-Mail: {legal.email || ''}
        </p>

        <h2>Vertretungsberechtigte Person</h2>
        <p>{legal.owner || ''}</p>

        <h2>Haftungsausschluss</h2>
        <p>Der Autor &uuml;bernimmt keine Gew&auml;hr f&uuml;r die Richtigkeit, Genauigkeit, Aktualit&auml;t, Zuverl&auml;ssigkeit und Vollst&auml;ndigkeit der Informationen.</p>

        <p><a href="index.html">&larr; Zur&uuml;ck zur Startseite</a></p>
      </div>
    </div>
  );
}
